import { combineReducers } from "redux";
import { builderListReducer } from "./builderListReducer";
import { builderDetailReducer } from "../shopDetail/reducer/reducer";

export const builderReducer = combineReducers({
  builderListReducer: builderListReducer,
  builderDetailReducer: builderDetailReducer
});
